export const tipTexts = [
  [
    '고객별로 링크를 생성하여 추적하면',
    '각 고객별로 어떤 고객이 읽었는지 안읽었는지',
    '심층적으로 분석이 가능해요',
  ],
  ['원하는 기능 업데이트가 있나요?', '아래 채널톡 버튼을 눌러 남겨보세요'],
  ['이 잠재고객은 몇 시에 출근할까?', '파일의 열람 시간을 확인해보세요'],
  ['지난 1주 내 2번 이상 자료를 본 고객이 있다면?', '추가로 설득해 보세요'],
  ['첨부한 자료를 “열어보고 싶게”', '궁금증 생기는 콜드메일을 써보세요'],
  [
    '탐나는 고객이 방금 파일을 열어봤나요?',
    '2시간 정도 후에 팔로우업을 해보세요!',
  ],
  ['추적용 링크를 만들어', '홈페이지나 우리회사 SNS 페이지에 걸어보세요'],
  [
    '지금 스트레칭 한 번 하세요.',
    '중요한 고객의 반응이 오면,',
    '세일즈클루가 이메일로 알려드릴게요',
  ],
] as const;

export const tipInterval = 5000;
